// extracted by mini-css-extract-plugin
module.exports = {"visible":"SwitchBackCards_visible__bEeXs"};